import { render } from "./FullscreenForm.vue?vue&type=template&id=1c907970&scoped=true"
import script from "./FullscreenForm.vue?vue&type=script&lang=js"
export * from "./FullscreenForm.vue?vue&type=script&lang=js"

import "./FullscreenForm.vue?vue&type=style&index=0&id=1c907970&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c907970"]])

export default __exports__